export default {
  'dynamicLink2.header': '<b>Caution:</b> You are about to leave this site.',
  'dynamicLink2.content':
    "By clicking 'Continue' below, you will be directed to our 3rd party vendor site.",
  'dynamicLink2.continue': 'Continue',
  'dynamicLink2.cancel': 'Cancel'
};
